import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { Normalize } from 'styled-normalize';
import { ThemeProvider } from 'styled-components';
import { useSelector } from 'react-redux';

import AppRoutes from './AppRoutes';
import BodyStyle from './BodyStyle';
import GladlySupportChat from './GladlySupportChat';
import theme from '@ad-scripts/presentation/themes/default';
import { LayoutContainer } from './layouts/Layout';
import { RootState } from 'src/actions/configuration/rootReducer';
import Toasts from 'src/presentation/components/Toasts';
import { ToastsPortal } from './agent_desktop_components';

const App: FC = () => {
  const initialized = useSelector((state: RootState) => state.initialized);
  const auth = useSelector((state: RootState) => state.auth);
  useRedirectToLogin(initialized, auth);

  if (!initialized.complete && !initialized.temporary) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <Normalize />
        <BodyStyle />

        <LayoutContainer className="appLayoutContainer">
          <AppRoutes auth={auth} />
        </LayoutContainer>

        <GladlySupportChat />
        <Toasts />
        <div id="modalPortal" />
        <StyledToastsPortal />
      </React.Fragment>
    </ThemeProvider>
  );
};

const StyledToastsPortal = styled(ToastsPortal)`
  bottom: unset;
  left: unset;
  pointer-events: inherit;
  right: 1.5rem;
  top: 1.5rem;
`;

// Will redirect to Agent Desktop's login page if we're missing an authenticated user after
// initializing the app (which grabs the auth from local storage).
const useRedirectToLogin = (initialized, auth) => {
  useEffect(() => {
    if (initialized.complete && !auth.userId && !initialized.temporary) {
      window.location.replace(`/user/login?fromPath=${window.location.pathname}`);
    }
  }, [initialized, auth.userId]);
};

export default App;
